/**
 * Who may edit or delete a dashboard someone else made — RBAC-7.4 bundle 7.
 *
 * The dashboards and dashboard_widgets write policies
 * (`supabase/migrations/20261103d1_rbac_7_4_dashboards_bundle.sql`) admit, besides the owner and
 * anyone the owner shared edit with:
 *   - `system.override`: every dashboard in every account (the platform operator);
 *   - `settings.admin`: every dashboard in the caller's own account.
 *
 * `DashboardService.canEditDashboard` asked the role NAMES 'Superadmin' and 'Admin' until bundle 7.
 * It now asks these two permissions, so the edit controls appear exactly where the API allows the
 * write. `dashboardAccess.test.ts` reads the migration and the service and fails if they drift.
 */
export const DASHBOARD_PLATFORM_PERMISSION = 'system.override';
export const DASHBOARD_ACCOUNT_ADMIN_PERMISSION = 'settings.admin';

/** The authority half of canEditDashboard; ownership and sharing are checked separately. */
export function adminMayEditDashboard(args: {
  holdsPlatform: boolean;
  holdsAccountAdmin: boolean;
  dashboardTenantId: string | null | undefined;
  currentTenantId: string | null | undefined;
}): boolean {
  if (args.holdsPlatform) return true;
  return args.holdsAccountAdmin && !!args.currentTenantId && args.dashboardTenantId === args.currentTenantId;
}
